import { MenuItem, Select } from '@material-ui/core'
import { supportedDeliveryModels } from 'constants/supportedDeliveryModels'
import { useDeliveryModel, useFeatureFlags, useUser } from 'hooks'
import { ChangeEvent, useEffect, useMemo } from 'react'
import { PartnerPortalDeliveryModel } from 'types'
import { deliveryModelToDisplayText } from 'utils'
import { useStyles } from './index.styles'

const DeliveryModelToggle = () => {
  const classes = useStyles()
  const { allowedDeliveryModels } = useUser()
  const { deliveryModel, setDeliveryModel } = useDeliveryModel()
  const [isNeoEnabled] = useFeatureFlags(['NEO'])
  const onChange = (event: ChangeEvent<{ value: PartnerPortalDeliveryModel }>) => setDeliveryModel(event.target.value)

  const options = useMemo(() => {
    if (allowedDeliveryModels.length) {
      return allowedDeliveryModels
        .filter((deliveryModel) => supportedDeliveryModels.has(deliveryModel))
        .map((deliveryModel) => ({
          name: deliveryModelToDisplayText[deliveryModel] || deliveryModel,
          value: deliveryModel,
        }))
    }

    return [{ name: 'Delivery Model Unknown', value: 'UNKNOWN' }]
  }, [allowedDeliveryModels])

  const firstOptionValue = options[0]?.value
  const valueInOptions = firstOptionValue && options.some((o) => o.value === deliveryModel)
  const effectiveValue = valueInOptions ? deliveryModel : firstOptionValue ?? 'UNKNOWN'

  useEffect(() => {
    if (firstOptionValue && firstOptionValue !== 'UNKNOWN' && !valueInOptions) {
      setDeliveryModel(firstOptionValue as PartnerPortalDeliveryModel)
    }
  }, [firstOptionValue, setDeliveryModel, valueInOptions])

  if (isNeoEnabled || allowedDeliveryModels.length === 0) {
    return null
  }

  return (
    <Select
      classes={{
        icon: classes.icon,
        select: classes.select,
      }}
      disableUnderline
      label="Delivery Model"
      // @ts-expect-error ??? This is a standard change event
      onChange={onChange}
      size="small"
      value={effectiveValue}
      variant="standard"
    >
      {options.map(({ name, value }) => (
        <MenuItem key={value} value={value}>
          {name}
        </MenuItem>
      ))}
    </Select>
  )
}

export { DeliveryModelToggle }
